<template>
  <div class="appPage">
    <div class="app" id="app">
      <router-view />
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  }
}
</script>

<style lang="scss">
body {
  --main-color: #3FC435;
  --theme-back: #000040;
  --sub-back: #0E0E51;
  --content-back: #200872;
  --back-color: #f7f7f7;
  --theme-font-color: #ffffff;
  --warn-color: #FFC300;
  --charge-color: #FF8D1A;

  --main-shadow: 0 0 20px 3px #00000010;
  --td-brand-color: var(--main-color);

  margin: 0;
  min-width: 1080px;
  user-select: none;
  background-color: var(--back-color);
}

.t_c {
  text-align: center;
}

.flex {
  display: flex;
}

.j_b {
  justify-content: space-between;
}

.j_c {
  justify-content: center;
}

.j_e {
  justify-content: space-evenly;
}

.a_c {
  align-items: center;
}

.f_c {
  flex-direction: column;
}

.m_left {
  margin-left: auto;
}

.gap {
  gap: 12px;
}

.bold {
  font-weight: 600;
}

.b_b {
  padding: 6px 12px;
  border-bottom: 1px solid #eeeeee;
  font-size: 14px;
}

.page-box {
  .content-left {
    width: calc(50% - 16px);
    // min-width: 18em;
    height: 100%;
    padding-right: 16px;
    // padding: 0 16px 0 16px;
    // margin: 32px 0 16px 0;
    overflow-x: auto;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 5px;
    }
  }

  .content-left-out {
    .content-left {
      height: calc(100% - 48px);
    }

    .pagination {
      height: 48px;
      padding-left: 12px;
    }
  }

  .content-border {
    border-left: 2px dashed #f4f4f4;
  }

  .content-right {
    // width: calc(50% - 16px);
    flex: 1;
    height: 100%;
    padding-left: 16px;
    // padding: 0 16px 0 16px;
    // margin: 32px 0 16px 0;
    overflow-x: auto;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 5px;
      transition: 300ms;

      &:hover {
        background-color: #ccc;
      }
    }
  }

  .content-right-out {
    .content-right {
      height: calc(100% - 108px);
    }

    .pagination {
      height: 48px;
      padding-left: 12px;
    }
  }
}

.tag {
  font-weight: 500;
  padding: 3px 6px;
  border-radius: 6px;
  transition: 300ms;
  font-size: 10px;
  line-height: 1.4em;
  width: max-content;
  display: inline-block;

  &.success {
    color: #00bd00;
    border: 1px solid #00bd00;
  }

  &.primary {
    color: #25A3FF;
    border: 1px solid #25A3FF;
  }

  &.warn {
    color: #d57011;
    border: 1px solid #d57011;
  }

  &.danger {
    color: #d51111;
    border: 1px solid #d51111;
  }

  &.default {
    color: #808080;
    border: 1px solid #808080;
  }
}

.ui-checkbox {
  --primary-color: #1677ff;
  --secondary-color: #fff;
  --primary-hover-color: #4096ff;
  /* checkbox */
  --checkbox-diameter: 18px;
  --checkbox-border-radius: 5px;
  --checkbox-border-color: #d9d9d9;
  --checkbox-border-width: 1px;
  --checkbox-border-style: solid;
  /* checkmark */
  --checkmark-size: 1;

  &,
  * {
    box-sizing: border-box;
  }

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: var(--checkbox-diameter);
  height: var(--checkbox-diameter);
  border-radius: var(--checkbox-border-radius);
  background: var(--secondary-color);
  border: var(--checkbox-border-width) var(--checkbox-border-style) var(--checkbox-border-color);
  transition: all 0.3s;
  cursor: pointer;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-shadow: 0 0 0 calc(var(--checkbox-diameter) / 2.5) var(--primary-color);
    border-radius: inherit;
    opacity: 0;
    transition: all 0.5s cubic-bezier(0.12, 0.4, 0.29, 1.46);
  }

  &::before {
    top: 40%;
    left: 50%;
    content: "";
    position: absolute;
    width: 4px;
    height: 7px;
    border-right: 2px solid var(--secondary-color);
    border-bottom: 2px solid var(--secondary-color);
    transform: translate(-50%, -50%) rotate(45deg) scale(0);
    opacity: 0;
    transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6), opacity 0.1s;
  }

  /* actions */
  &:hover {
    cursor: pointer;
    border-color: var(--primary-color);
  }

  &:checked {
    background: var(--primary-color);
    border-color: transparent;

    &::before {
      opacity: 1;
      transform: translate(-50%, -50%) rotate(45deg) scale(var(--checkmark-size));
      transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
    }
  }

  &:active:not(:checked)::after {
    transition: none;
    box-shadow: none;
    opacity: 1;
  }
}

.pagination {
  margin-top: 18px;
}

input, textarea {
  transition: 300ms;

  &:focus {
    outline: var(--main-color);
  }
}

*::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

*::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  border-radius: 5px;
  transition: 300ms;

  &:hover {
    background-color: #cccccc;
  }
}

.operates {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  .operate {
    cursor: pointer;
    display: inline-block;

    &.warn {
      color: #d57011;
    }

    &.primary {
      color: #25A3FF;
    }

    &.danger {
      color: #FF0000;
    }

    &.success {
      color: #37A570;
    }

    &.disabled {
      color: #999999;
      cursor: not-allowed;
    }
  }
}
</style>
